import { Entity } from 'mk2/schemas';
import { schema } from 'normalizr';

export interface NoteEntity extends Entity {
    note: string;
}

export const NoteSchema = new schema.Entity('notes.note', {});
